import { render } from "./NiceWords.vue?vue&type=template&id=bafba4ca&scoped=true&ts=true"
import script from "./NiceWords.vue?vue&type=script&lang=ts"
export * from "./NiceWords.vue?vue&type=script&lang=ts"

import "./NiceWords.vue?vue&type=style&index=0&id=bafba4ca&lang=scss&scoped=true"

import exportComponent from "/Users/thomasplanckaert/Dedalus/GIT/carteconfituur/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafba4ca"]])

export default __exports__